import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Box } from "@mui/material";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  borderSkipped: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
        barThickness: 4,
      },
    },
    y: {
      grid: {
        display: false,
      },
    },
  },
};

const labels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];


export function Barchart(props) {
  const data = {
   labels,
   datasets: [
     {
       barPercentage: 1,
       categoryPercentage: 0.5,
       label: "Dataset 1",
       data: props?.chartData,
       backgroundColor: ["#00649e57"],
       backgroundColorHover: ["#00649e57"],
     }
   ],
  };
  return(
    <Box className="box-wrapper br-24">
        <div className='heading-btn_wrapper'>
				<h5 className='fz-20 fw-bold'>{props.name}</h5>
			</div>
        <Bar options={options} data={data} />
    </Box>
  );
}
